// https://codepen.io/zadvorsky/pen/OJwQxo?editors=0010
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Animation } from '../../../../lib/classes/animation';
var HALF_PI = Math.PI * 0.5;
var ConfettiEffect = /** @class */ (function (_super) {
    __extends(ConfettiEffect, _super);
    function ConfettiEffect(props) {
        var _this = _super.call(this, props) || this;
        _this.maxTime = 2000;
        _this.particles = [];
        var width = props.width || window.innerWidth;
        var height = props.height || window.innerHeight;
        var maxWidth = Math.min(700, width);
        var randomX = function () { return width / 2 - maxWidth / 2 + Math.random() * maxWidth; };
        var randomY = function () { return Math.random() * height; };
        for (var i = 0; i < 128; i++) {
            var p0 = new Point(width * 0.5, height * 0.5);
            var p1 = new Point(randomX(), randomY());
            var p2 = new Point(randomX(), randomY());
            var p3 = new Point(randomX(), height + 64);
            _this.particles.push(new Particle(p0, p1, p2, p3));
        }
        _this.bg = props.bg;
        return _this;
    }
    ConfettiEffect.prototype.upd = function (dt) {
        var _this = this;
        _super.prototype.upd.call(this, dt);
        if (this.done)
            return;
        this.done = true;
        this.particles.forEach(function (p) {
            p.upd(dt);
            if (!p.complete)
                _this.done = false;
        });
        if (this.time >= this.maxTime)
            this.done = true;
        if (this.done && this.props.onDone)
            this.props.onDone();
    };
    ConfettiEffect.prototype.isDone = function () {
        return this.done;
    };
    ConfettiEffect.prototype.draw = function (scene) {
        if (this.bg)
            scene.fillAll(this.bg);
        this.particles.forEach(function (p) { return p.draw(scene); });
    };
    return ConfettiEffect;
}(Animation));
export { ConfettiEffect };
var Particle = /** @class */ (function () {
    function Particle(p0, p1, p2, p3) {
        this.p0 = p0;
        this.p1 = p1;
        this.p2 = p2;
        this.p3 = p3;
        this.time = 0;
        this.duration = 3 + Math.random() * 2;
        this.color = '#' + Math.floor(Math.random() * 0xffffff).toString(16);
        this.w = 8;
        this.h = 6;
        this.complete = false;
    }
    Particle.prototype.upd = function (dt) {
        this.time = Math.min(this.duration, this.time + dt / 1000);
        var f = Ease.outCubic(this.time, 0, 1, this.duration);
        var p = cubeBezier(this.p0, this.p1, this.p2, this.p3, f);
        var dx = p.x - this.x;
        var dy = p.y - this.y;
        this.r = Math.atan2(dy, dx) + HALF_PI;
        this.sy = Math.sin(Math.PI * f * 10);
        this.x = p.x;
        this.y = p.y;
        this.complete = this.time === this.duration;
    };
    Particle.prototype.draw = function (scene) {
        if (this.complete)
            return;
        scene.save();
        scene.translate(this.x, this.y);
        scene.rotate(this.r);
        scene.scale(1, this.sy);
        scene.fillRect(-this.w * 0.5, -this.h * 0.5, this.w, this.h, this.color);
        scene.restore();
    };
    return Particle;
}());
var Point = /** @class */ (function () {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    return Point;
}());
/**
 * easing equations from http://gizma.com/easing/
 * t = current time
 * b = start value
 * c = delta value
 * d = duration
 */
var Ease = {
    inCubic: function (t, b, c, d) {
        t /= d;
        return c * t * t * t + b;
    },
    outCubic: function (t, b, c, d) {
        t /= d;
        t--;
        return c * (t * t * t + 1) + b;
    },
    inOutCubic: function (t, b, c, d) {
        t /= d / 2;
        if (t < 1)
            return (c / 2) * t * t * t + b;
        t -= 2;
        return (c / 2) * (t * t * t + 2) + b;
    },
    inBack: function (t, b, c, d, s) {
        s = s || 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
};
function cubeBezier(p0, c0, c1, p1, t) {
    var p = new Point();
    var nt = 1 - t;
    p.x = nt * nt * nt * p0.x + 3 * nt * nt * t * c0.x + 3 * nt * t * t * c1.x + t * t * t * p1.x;
    p.y = nt * nt * nt * p0.y + 3 * nt * nt * t * c0.y + 3 * nt * t * t * c1.y + t * t * t * p1.y;
    return p;
}
